import * as ActionTypes from './actionTypes'

export function toggle(name) {
  return {
    type: ActionTypes.TOGGLE_ITEM_COLLAPSE,
    name
  }
}